import smrtb from 'smrtb-pbjs'
import 'smrtb-pbjs/modules/rubiconBidAdapter'
import 'smrtb-pbjs/modules/sovrnBidAdapter'
import 'smrtb-pbjs/modules/synacormediaBidAdapter'
import 'smrtb-pbjs/modules/sonobiBidAdapter'
import 'smrtb-pbjs/modules/ixBidAdapter'
import 'smrtb-pbjs/modules/33acrossBidAdapter'
import 'smrtb-pbjs/modules/eplanningBidAdapter'
import 'smrtb-pbjs/modules/conversantBidAdapter'
import 'smrtb-pbjs/modules/vidazooBidAdapter'
import 'smrtb-pbjs/modules/adyoulikeBidAdapter'
import 'smrtb-pbjs/modules/teadsBidAdapter'
import 'smrtb-pbjs/modules/appnexusBidAdapter'
import 'smrtb-pbjs/modules/rhythmoneBidAdapter'
import 'smrtb-pbjs/modules/aolBidAdapter'
import 'smrtb-pbjs/modules/openxBidAdapter'
import 'smrtb-pbjs/modules/emx_digitalBidAdapter'
import 'smrtb-pbjs/modules/districtmDMXBidAdapter'
import 'smrtb-pbjs/modules/gumgumBidAdapter'
import 'smrtb-pbjs/modules/nobidBidAdapter'
import 'smrtb-pbjs/modules/sortableBidAdapter'
import 'smrtb-pbjs/modules/spotxBidAdapter'
import 'smrtb-pbjs/modules/tripleliftBidAdapter'
import 'smrtb-pbjs/modules/medianetBidAdapter'
import 'smrtb-pbjs/modules/undertoneBidAdapter'
import 'smrtb-pbjs/modules/onetagBidAdapter'
import 'smrtb-pbjs/modules/brightcomBidAdapter'
import 'smrtb-pbjs/modules/kubientBidAdapter'

import Logger from '../Log'
import { topmostWindowFrame } from '../utils'

const Log = Logger.for('PbBootstrap')

export default class {
  constructor (auctionTracker) {
    this._auctionTracker = auctionTracker

    auctionTracker.register(smrtb)
  }

  aliasBidder (from, to) {
    Log.debug('Registering bidder alias: ' + from + ' -> ' + to)
    smrtb.aliasBidder(from, to)
  }

  setConfig (config) {
    if (!config) {
      throw Error('No prebid config supplied')
    }

    const params = new URLSearchParams(topmostWindowFrame().location.search)
    // Enable all syncing by default
    const cfg = Object.assign({}, {
      maxRequestsPerOrigin: 6,
      bidderTimeout: 800,
      userSync: {
        aliasSyncEnabled: true,
        filterSettings: {
          iframe: {
            bidders: '*',
            filter: 'include'
          },
          image: {
            bidders: '*',
            filter: 'include'
          }
        }
      },
      cache: { url: null }
    }, config, { debug: (params.get('smrtb_debug') === 'true') })

    smrtb.setConfig(cfg)
  }

  requestBids (adUnits, callback, attempts = 2) {
    smrtb.processQueue()

    attempts--

    if (typeof callback !== 'function') {
      throw Error('Missing bidsBackHandler argument')
    }

    const bidsBackHandler = (bids, timedOut, auctionId) => {
      if (!bids) {
        Log.warn('Some issue prevented prebid from holding an auction it appears, bids object null')
        return callback(null, auctionId)
      }

      if (bids.length === 0 && attempts > 0) {
        Log.debug('Retrying for bids after auction id ' + auctionId)
        return this.requestBids(adUnits, callback, attempts)
      }

      if (Object.keys(bids).length === 0) {
        /*
         * If no bidders match an auction, Prebid.js won't invoke
         * _onAuctionInit(), so we'll have to do it manually.
         */
        this._auctionTracker._onAuctionInit({ auctionId })
      }
      callback(bids, auctionId)
    }

    smrtb.requestBids({
      adUnits,
      bidsBackHandler
    })
  }
}
